import styled from 'styled-components';

export default styled.section`
	--gap: var(--spacing-large);
	display: flex;
	flex-direction: column;
	gap: var(--gap);
	flex: 1;
	padding-bottom: var(--gap);

	.row {
		display: flex;
	}

	.add-delegate-list {
		display: flex;
		flex-direction: column;
		gap: inherit;
		.add-delegate-item {
			display: flex;
			align-items: baseline;
			gap: var(--gap);
		}
	}

	.delegate-list {
		display: flex;
		flex-direction: column;
		gap: var(--gap);
		flex: 1;
		&.empty {
			justify-content: center;
		}
		.delegate-user-data {
			display: flex;
			align-items: center;
		}
	}
`;
